import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage for web
import rootReducer from "../reducers";
import { encryptTransform } from "../utils/encryptTransform";

const persistConfig = {
  key: "root",
  storage,
  transforms: [encryptTransform],
  whitelist: ["auth"] // only persist auth slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);